import store from '@/store'

export function hasAdminRole(to) {
  
  if (to?.meta?.requiresPermission) {
    
    if ((Array.isArray(to?.meta?.requiresPermission))) {
      if (to?.meta?.requiresPermission?.some(e => e?.isAdmin)) {
        return store?.getters?.organizations?.some(org => org?.IsAdmin)
      } else {
        return true
      }
    }
    
    if (!Array.isArray(to?.meta?.requiresPermission)) {
      if (to?.meta?.requiresPermission?.isAdmin) {
        return store?.getters?.organizations?.some(org => org?.IsAdmin)
      } else {
        return true
      }
    } else {
      // no need for permission-check
      // access granted
      return true
    }
  }
}
